// @flow

export const goto = (url) => {
  window.location.assign(url);
};